import { type Mode, type PathsAppState, type SiteInfoAppState } from "@client/types";

export type Session = {
  countryCode: string;
  cultureCode: string;
  currencyCode: string;
};

export type Globals = {
  mode: Mode;
  paths: PathsAppState;
  siteInfo: SiteInfoAppState;
  version: string;
};
export const globals: Globals = {
  mode: "app",
  paths: {
    apiUrl: "",
    assetsUrl: "",
    awsS3Url: "",
    awsS3RootUrl: "",
    baseUrl: "",
    internalMediaUrl: "",
    mediaServiceUrl: "",
    templatesServiceUrl: "",
    uploadsMediaUrl: ""
  },
  siteInfo: {
    adminLoginUrl: "",
    cartPageId: "",
    loginPageId: "",
    logoutUrl: "",
    notFoundPageId: "",
    profilePageId: "",
    registerPageId: "",
    searchPageId: "",
    brandKey: "Funnelr",
    systemPopupIds: {
      eventPopupId: ""
    },
    title: ""
  },
  version: ""
};

export const initGlobals = (data: Globals) => {
  Object.assign(globals, data);
};

export const patchGlobals = (data: Partial<Globals>) => {
  Object.assign(globals, data);
};
